import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

function useStudentCycles() {
  return useQuery({
    queryKey: ["student", "cycles"],
    queryFn: async () => {
      const res = await apiClient.get("/api/v1/me/student/cycles/");
      return res.data;
    },
  });
}

export { useStudentCycles };
